/**
 * Migration Wizard page — /settings/migration
 *
 * Composes the WizardShell with step-specific content components.
 * Each step is a separate component for code splitting and clarity.
 */
import { WizardShell, WIZARD_STEPS } from "./wizard-shell";
import { ConnectStep } from "./steps/connect-step";
import { DiscoverStep } from "./steps/discover-step";
import { MapStep } from "./steps/map-step";
import { PreviewStep } from "./steps/preview-step";
import { ExecuteStep } from "./steps/execute-step";
import { VerifyStep } from "./steps/verify-step";

export default function MigrationWizardPage() {
  return (
    <WizardShell>
      {(props) => {
        const step = WIZARD_STEPS[props.state.currentStep];
        if (!step) return null;
        const stepKey = step.key;

        switch (stepKey) {
          case "connect":
            return <ConnectStep {...props} />;
          case "discover":
            return <DiscoverStep {...props} />;
          case "map":
            return <MapStep {...props} />;
          case "preview":
            return <PreviewStep {...props} />;
          case "execute":
            return <ExecuteStep {...props} />;
          case "verify":
            return <VerifyStep {...props} />;
          default:
            return null;
        }
      }}
    </WizardShell>
  );
}
